let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lOE6p")).then(() => parcelRequire('ft7Ls'));